export const URL = "https://chatbotchec.website/reglasDifusion";

//producccion
/*export const URL = "https://infociad.herokuapp.com/api";
export const URL_INDEXACION = "https://infociad.herokuapp.com/uploads";
*/

export const SERVICES = {
	GETBYNIU:"/getUser.php",
	INSERT_CHECK:"/signin",

	



	

};
